// Open the Report Bug dialog from anywhere. The dialog lives in the Layout (the sidebar's user menu
// opens it too), so a page asks for it with an event, as ProductTour's startTour() does, instead of
// reaching into the sidebar. The Help Center used to click the menu's own button, which exists only
// while that menu is open, so its "Report a Bug" did nothing (2026-09-23).
export const OPEN_BUG_REPORT = 'open-bug-report';

export function openBugReport() {
  window.dispatchEvent(new Event(OPEN_BUG_REPORT));
}
